import { stringify } from 'query-string';

import { BASE_URL_V2 } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'MASTERY_HOME_GET',
  GET_SUCCESS: 'MASTERY_HOME_GET_SUCCESS',
  GET_FAILURE: 'MASTERY_HOME_GET_FAILURE',
};

type MasteryHomeQuery = {
  in_class: boolean;
  user_type: string;
  class_start_time?: string;
};

export const get = actions.get(
  (studentId: string, query: MasteryHomeQuery) =>
    `${BASE_URL_V2}/students/${studentId}/mastery-home/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
